import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Badges.module.scss';

const Badges = ({ badges }) => (
  <div className={styles.root}>
    {badges.map((badge) => (
      <div
        key={badge}
        className={classNames(styles.badge, styles[`badge${badge}`])}
      >
        {badge}
      </div>
    ))}
  </div>
);

Badges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default memo(Badges);
